<!-- Root Fixed Header Container: no backdrop-filter on root to prevent CSS fixed containing block trap -->
<header
    class="fixed top-0 right-0 left-0 z-40 w-full"
    (mouseleave)="scheduleClose()"
>
    <!-- 1. The 64px Frosted Glass Navbar Bar -->
    <div
        class="h-16 w-full border-b px-4 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.7)] backdrop-blur-xl backdrop-saturate-150 transition-all duration-200 sm:px-6 lg:px-8"
        [class.bg-white]="activeMenu() !== null"
        [class.bg-white/85]="activeMenu() === null"
        [class.border-slate-200/80]="isScrolled()"
        [class.border-slate-200/50]="!isScrolled()"
        [class.shadow-xs]="isScrolled()"
        [class.shadow-slate-900/5]="isScrolled()"
        (mouseenter)="cancelClose()"
    >
        <div
            class="mx-auto flex h-full w-full max-w-[96rem] items-center justify-between"
        >
            <!-- Left: Mobile Menu Toggle & Brand Logo -->
            <div class="flex h-full shrink-0 items-center gap-3">
                <button
                    type="button"
                    class="focus-visible:ring-primary flex h-10 w-10 items-center justify-center rounded-xl text-slate-700 transition-colors hover:bg-slate-100 focus-visible:ring-2 focus-visible:outline-none md:hidden"
                    (click)="toggleMobileMenu()"
                    aria-label="Toggle navigation menu"
                    [attr.aria-expanded]="isMobileMenuOpen()"
                >
                    @if (isMobileMenuOpen()) {
                        <ng-icon name="lucideX" class="h-6 w-6" />
                    } @else {
                        <ng-icon name="lucideMenu" class="h-6 w-6" />
                    }
                </button>

                <a
                    routerLink="/"
                    (click)="closeAllMenus()"
                    class="focus-visible:ring-primary flex items-center gap-2 rounded-lg p-0.5 focus-visible:ring-2 focus-visible:outline-none"
                    aria-label="Cj Club Home"
                >
                    <img
                        src="assets/images/cjc.svg"
                        alt="CJC Public"
                        class="h-9 w-auto object-contain md:h-11"
                    />
                </a>
            </div>

            <!-- Center: Primary Desktop Navigation (Full-height hover zones) -->
            <nav
                class="hidden h-full items-center gap-1 md:flex lg:gap-2"
                role="navigation"
                aria-label="Main Navigation"
            >
                <!-- 1. Deals Trigger -->
                <div
                    class="relative flex h-full items-center"
                    (mouseenter)="openMenu('deals')"
                >
                    <button
                        type="button"
                        class="group focus-visible:ring-primary flex cursor-pointer items-center gap-1.5 rounded-xl px-3.5 py-2 text-sm font-medium transition-all duration-150 focus-visible:ring-2 focus-visible:outline-none"
                        [ngClass]="
                            activeMenu() === 'deals'
                                ? 'bg-primary/10 text-primary font-semibold'
                                : 'text-slate-700 hover:bg-slate-100/80 hover:text-slate-900'
                        "
                        (click)="toggleNavMenu('deals', $event)"
                        [attr.aria-expanded]="activeMenu() === 'deals'"
                        aria-haspopup="true"
                    >
                        <span>Deals</span>
                        <ng-icon
                            name="lucideChevronDown"
                            class="h-3.5 w-3.5 transition-transform duration-300 ease-out"
                            [class.rotate-180]="activeMenu() === 'deals'"
                            [class.text-primary]="activeMenu() === 'deals'"
                        />
                    </button>
                </div>

                <!-- 2. Fun Trigger -->
                <div
                    class="relative flex h-full items-center"
                    (mouseenter)="openMenu('fun')"
                >
                    <button
                        type="button"
                        class="group focus-visible:ring-primary flex cursor-pointer items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-medium transition-all duration-150 focus-visible:ring-2 focus-visible:outline-none"
                        [ngClass]="
                            activeMenu() === 'fun'
                                ? 'bg-primary/10 text-primary font-semibold'
                                : 'text-slate-700 hover:bg-slate-100/80 hover:text-slate-900'
                        "
                        (click)="toggleNavMenu('fun', $event)"
                        [attr.aria-expanded]="activeMenu() === 'fun'"
                        aria-haspopup="true"
                    >
                        <span class="relative flex items-center gap-1.5">
                            <span>Fun</span>
                            <span class="relative flex h-1.5 w-1.5">
                                <span
                                    class="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-75"
                                ></span>
                                <span
                                    class="relative inline-flex h-1.5 w-1.5 rounded-full bg-amber-500"
                                ></span>
                            </span>
                        </span>
                        <ng-icon
                            name="lucideChevronDown"
                            class="h-3.5 w-3.5 transition-transform duration-300 ease-out"
                            [class.rotate-180]="activeMenu() === 'fun'"
                            [class.text-primary]="activeMenu() === 'fun'"
                        />
                    </button>
                </div>

                <!-- 3. Jobs Direct Link -->
                <div
                    class="flex h-full items-center"
                    (mouseenter)="closeAllMenus()"
                >
                    <a
                        routerLink="/jobs"
                        (click)="closeAllMenus()"
                        class="focus-visible:ring-primary flex items-center gap-1.5 rounded-xl px-3.5 py-2 text-sm font-medium text-slate-700 transition-all duration-150 hover:bg-slate-100/80 hover:text-slate-900 focus-visible:ring-2 focus-visible:outline-none"
                        routerLinkActive="bg-primary/10 text-primary font-semibold"
                    >
                        <span>Jobs</span>
                    </a>
                </div>
            </nav>

            <!-- Right: Account Profile / Sign In CTA -->
            <div class="flex shrink-0 items-center gap-2">
                <app-header-profile-menu
                    [userName]="userName()"
                    [userRole]="userRole()"
                    [userEmail]="userEmail()"
                />
            </div>
        </div>
    </div>

    <!-- 2. Desktop Mega Menu Dropdowns (Deals & Fun encapsulated child component) -->
    <app-header-client-mega-menu
        [activeMenu]="activeMenu()"
        [dealGroups]="dealGroups"
        [funActivities]="funActivities"
        (menuEnter)="cancelClose()"
        (menuLeave)="scheduleClose()"
        (menuClose)="closeAllMenus()"
    />
</header>

<!-- Desktop Dimming Backdrop -->
@if (activeMenu() !== null) {
    <div
        class="fixed inset-0 top-16 z-30 hidden bg-slate-900/15 backdrop-blur-[2px] transition-opacity duration-200 md:block"
        (click)="closeAllMenus()"
        aria-hidden="true"
    ></div>
}

<!-- Responsive Mobile Drawer (Encapsulated child component) -->
<app-header-client-mobile-drawer
    [isOpen]="isMobileMenuOpen()"
    [dealGroups]="dealGroups"
    [funActivities]="funActivities"
    [isLoggedIn]="isLoggedIn()"
    [displayName]="displayName()"
    [displayEmail]="displayEmail()"
    [displayRole]="displayRole()"
    [displayInitials]="displayInitials()"
    [showClientDashboard]="showClientDashboard()"
    (closeDrawer)="closeMobileMenu()"
    (logout)="logout()"
/>
